import login from "./login";
import logout from "./logout";
import fetchServersList from "./fetch-servers";
import fetchServersDetails from "./fetch-servers-details";
import fetchAggregators from "./fetch-aggregators";
import fetchAggregatorDetails from "./fetch-aggregators-details";
import fetchZegebaContacts from "./fetch-zegeba-contacts";
import addServerDetails from "./add-server-details";
import addZegebaContact from "./add-zegeba-contact";
import fetchMeta from "./fetch-meta";
import refreshToken from "./refresh-token";
import fetchUsers from "./fetch-users";
import addUser from "./add-user";
import updateUser from "./update-user";
import requestResetPassword from "./request-reset-password";
import resetPassword from "./reset-password";
import validateNonce from "./validate-nonce";

export default {
	login,
	logout,
	fetchServersList,
	fetchServersDetails,
	fetchAggregators,
	fetchAggregatorDetails,
	fetchZegebaContacts,
	addServerDetails,
	addZegebaContact,
	fetchMeta,
	refreshToken,
	fetchUsers,
	addUser,
	updateUser,
	requestResetPassword,
	resetPassword,
	validateNonce
};



// WEBPACK FOOTER //
// ./src/api/index.js